import React from 'react';
import {
  FDStack, FDSecondaryActionButton, FDLabelText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { advisorPage } from 'Consts/Strings';

const ProfileSection = ({ relationship }) => {
  return (
    <FDStack alignItems={'center'} direction={'column'} paddingY={4} spacing={2}>
      <FDLabelText value={'Billing and email editing has moved to the Profile'} />
      <FDSecondaryActionButton
        icon={'link'}
        label={relationship?.meta('prompt')}
        href={buildPageLink(
          relationship?.link('related').url(),
          advisorPage,
        )}
      />
    </FDStack>
  );
};

ProfileSection.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default ProfileSection;
